<div [ngClass]="classes?.formClasses" *ngIf="inputTypeConfiguration">

  <!-- Label with optional tooltip -->
  <div *ngIf="inputTypeConfiguration.includeLeftLabel">
      <label [attr.for]="formElementId">
          {{ inputTypeConfiguration.labelText }}
          <span *ngIf="inputTypeConfiguration.labelTooltip" [ngbTooltip]="inputTypeConfiguration.labelTooltip">
          </span>
      </label>
  </div>

  <!-- Free Text Input -->
  <div *ngIf="isFreeText()" [ngClass]="classes?.containerClasses">
      <label *ngIf="inputTypeConfiguration?.includeLabel" [for]="formElementId">{{ inputTypeConfiguration.labelText }}</label>
      <input type="text" class="form-control" [id]="formElementId" [ngClass]="classes?.formControlClasses" [disabled]="!canEdit"
            [required]="valueIsRequired(value)" [minlength]="minLength" [maxlength]="maxLength"
            [(ngModel)]="value" [placeholder]="placeholderText" [attr.aria-label]="ariaLabelText"
            (ngModelChange)="setValueUpdated()" #valueFormFields="ngModel" />
      <!-- Bootstrap uses 'invalid-feedback' class for errors, shown conditionally -->
      <div *ngIf="valueIsRequired(value) && valueFormFields.errors?.required" class="invalid-feedback">Required</div>
      <div *ngIf="valueFormFields.errors?.minlength" class="invalid-feedback">Value must be at least {{ minLength }} characters</div>
      <div *ngIf="valueFormFields.errors?.maxlength" class="invalid-feedback">Value must not exceed {{ maxLength }} characters</div>
  </div>

  <!-- Paragraph -->
  <div *ngIf="isParagraph()" class="custom-input-type" [ngClass]="classes?.containerClasses">
      <label *ngIf="inputTypeConfiguration?.includeLabel" [for]="formElementId">{{ inputTypeConfiguration.labelText }}</label>
      <textarea class="form-control" [id]="formElementId" [ngClass]="classes?.formControlClasses"
                [disabled]="!canEdit" [required]="valueIsRequired(value)"
                [maxlength]="4000" [rows]="inputTypeConfiguration?.rowsInParagraph"
                [(ngModel)]="value" [placeholder]="placeholderText" [attr.aria-label]="ariaLabelText"
                (ngModelChange)="setValueUpdated()" #valueFormFields="ngModel"></textarea>
      <div *ngIf="valueIsRequired(value) && valueFormFields.errors?.required" class="invalid-feedback">Required</div>
      <div *ngIf="valueFormFields.errors?.maxlength" class="invalid-feedback">Value must not exceed 4000 characters</div>
  </div>

  <!-- Numeric Integer -->
  <div *ngIf="isNumericInt()" class="custom-input-type" [ngClass]="classes?.containerClasses">
      <label *ngIf="inputTypeConfiguration?.includeLabel" [for]="formElementId">{{ inputTypeConfiguration.labelText }}</label>
      <input type="number" class="form-control" [id]="formElementId" [ngClass]="classes?.formControlClasses"
            [disabled]="!canEdit" [required]="valueIsRequired(value)"
            min="-1000000000" max="1000000000" step="1" [(ngModel)]="value"
            [placeholder]="placeholderText" [attr.aria-label]="ariaLabelText"
            (ngModelChange)="setValueUpdated()" #valueFormFields="ngModel" />
      <div *ngIf="valueIsRequired(value) && valueFormFields.errors?.required" class="invalid-feedback">Required</div>
      <div *ngIf="valueFormFields.errors?.min || valueFormFields.errors?.max" class="invalid-feedback">Invalid Value</div>
  </div>

  <!-- Dropdown -->
  <div *ngIf="isDropDown()" [ngClass]="classes?.containerClasses">
      <label *ngIf="inputTypeConfiguration?.includeLabel" [for]="formElementId">{{ inputTypeConfiguration.labelText }}</label>
      <select class="form-control" [id]="formElementId" [ngClass]="classes?.formControlClasses" [disabled]="!canSelectFromDropdown()"
              [required]="valueIsRequired(value)" [(ngModel)]="value" (ngModelChange)="setValueUpdated()" #valueFormFields="ngModel">
          <option *ngIf="inputTypeConfiguration?.includeBlankOptionInDropdown" [value]="null"></option>
          <option *ngFor="let option of options" [value]="option.id">{{ option.name }}</option>
      </select>
      <div *ngIf="valueIsRequired(value) && valueFormFields.errors?.required" class="invalid-feedback">Required</div>
  </div>

  <!-- Currency -->
  <div *ngIf="isCurrency() && !inputTypeConfiguration?.standardInputStyling" class="custom-input-type" [ngClass]="classes?.containerClasses">
      <label *ngIf="inputTypeConfiguration?.includeLabel" [for]="formElementId">{{ inputTypeConfiguration.labelText }}</label>
      <input type="text" class="form-control" [id]="formElementId" [ngClass]="classes?.formControlClasses"
            [disabled]="!canEdit" [required]="valueIsRequired(value)"
            [(ngModel)]="value" [placeholder]="placeholderText" [attr.aria-label]="ariaLabelText"
            (ngModelChange)="setValueUpdated()" #valueFormFields="ngModel" />
      <div *ngIf="valueIsRequired(value) && valueFormFields.errors?.required" class="invalid-feedback">Required</div>
  </div>

  <!-- Checkbox -->
  <div *ngIf="isCheckbox()" class="form-check" [id]="formElementId" [ngClass]="classes?.formControlClasses">
      <input type="checkbox" class="form-check-input" [disabled]="!canEdit" [(ngModel)]="value"
             [indeterminate]="valueIsIndeterminate(value)" [required]="valueIsRequired(value)"
             (ngModelChange)="setValueUpdated()" [attr.aria-label]="ariaLabelText" [checked]="value === true" #valueFormFields="ngModel">
      <label class="form-check-label" [for]="formElementId">{{ placeholderText }}</label>
      <div *ngIf="valueIsRequired(value) && valueFormFields.errors?.required" class="invalid-feedback">Required</div>
  </div>

  <!-- Date -->
  <div *ngIf="isDate()" class="custom-input-type" [ngClass]="classes?.containerClasses">
      <label *ngIf="inputTypeConfiguration?.includeLabel" [for]="formElementId">{{ inputTypeConfiguration.labelText }}</label>
      <input type="date" class="form-control" [id]="formElementId" [ngClass]="classes?.formControlClasses"
            [readonly]="!canEdit" [required]="valueIsRequired(value)"
            [(ngModel)]="value"
            [placeholder]="placeholderText" [attr.aria-label]="ariaLabelText"
            (ngModelChange)="setValueUpdated()" #valueFormFields="ngModel" />
      <div *ngIf="valueIsRequired(value) && valueFormFields.errors?.required" class="invalid-feedback">Required</div>
  </div>

  <!-- Year -->
  <div *ngIf="isYear()" class="custom-input-type" [ngClass]="classes?.containerClasses">
      <label *ngIf="inputTypeConfiguration?.includeLabel" [for]="formElementId">{{ inputTypeConfiguration.labelText }}</label>
      <input type="number" class="form-control" [id]="formElementId" [ngClass]="classes?.formControlClasses"
            [disabled]="!canEdit" [required]="valueIsRequired(value)"
            min="1000" max="9999" step="1" [(ngModel)]="value"
            [placeholder]="placeholderText" [attr.aria-label]="ariaLabelText"
            (ngModelChange)="setValueUpdated()" #valueFormFields="ngModel" />
      <div *ngIf="valueIsRequired(value) && valueFormFields.errors?.required" class="invalid-feedback">Required</div>
      <div *ngIf="valueFormFields.errors?.min || valueFormFields.errors?.max" class="invalid-feedback">Invalid Year Value</div>
  </div>

</div>
